import { jsx as _jsx } from "react/jsx-runtime";
const Stepper = ({ length, active, hidden, highlight, onClick, }) => {
    return (_jsx("div", { className: "stepper-wrapper", children: new Array(length).fill(null).map((_, idx) => {
            const isActive = active === idx;
            return (_jsx("div", { className: `stepper-button${isActive ? ' active' : ''}${hidden ? ' hidden' : ''}${highlight === idx ? ' highlight' : ''}`, onClick: () => onClick(idx), children: _jsx("div", { className: "stepper-button-graphics" }) }, idx));
        }) }));
};
export default Stepper;
